// extracted by mini-css-extract-plugin
export default {"image-cropper":"index_image-cropper__Lo7NG"};